<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="openUserGroupManager()">
            人员分组
          </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            （{{ userGroupInfo.MeetingUserGroupName }}）人员
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button @click="openUserGroupManager()"> 返回 </el-button>
        <el-button type="primary" @click="editUser(null)"> 新增学员 </el-button>
        <el-button type="primary" @click="exportTemplate()">
          导出Excel模板
        </el-button>
        <el-button type="primary" @click="importData()"> 导入数据 </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            {{ userGroupInfo.MeetingUserGroupName }}
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button @click="openUserGroupManager()"> 返回 </el-button>
            <el-button type="primary" @click="editUser(null)">
              新增学员
            </el-button>
            <el-button type="primary" @click="editExaminer(null)">
              新增阅卷人
            </el-button>
          </div>
          <div class="condition_item">
            <el-button type="primary" @click="exportTemplate()">
              导出Excel模板
            </el-button>
            <el-button type="primary" @click="importData()">
              导入数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="userList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        stripe
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column property="UserName" label="姓名"> </el-table-column>
        <el-table-column property="Phone" label="用户名" align="center">
        </el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="scope">
            <span>
              <i
                class="iconfont icon-zhuchiren"
                v-if="scope.row.RoleId === 2"
              ></i>
              <i
                class="iconfont icon-shezhijiaose"
                v-if="scope.row.RoleId === 7"
              ></i>
              <span v-if="scope.row.RoleId !== 7"> 学员 </span>
              <span v-if="scope.row.RoleId === 7"> 阅卷人 </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column property="Password" label="密码" align="center">
        </el-table-column>
        <el-table-column label="显示顺序" width="70" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editUser(scope.row.GroupStaffID)"
              v-if="scope.row.RoleId === 0"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editExaminer(scope.row.GroupStaffID)"
              v-if="scope.row.RoleId === 7"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteUser(scope.row)"
              v-if="scope.row.VoteNames.length === 0"
            >
              删除
            </el-link>
            <el-popover placement="left" width="400" trigger="hover">
              <el-table :data="scope.row.VoteNames">
                <el-table-column width="400" label="被以下问卷使用">
                  <template slot-scope="scope1">
                    <span>{{ scope1.row }}</span>
                  </template></el-table-column
                >
              </el-table>
              <el-link
                title="被以下问卷使用"
                type="primary"
                class="cell_link"
                slot="reference"
                v-if="scope.row.VoteNames.length !== 0"
                :disabled="scope.row.VoteNames.length !== 0"
              >
                删除
                <i class="el-icon-connection el-icon--right"></i>
              </el-link>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditUser
        :MeetingGroupID="userGroupId"
        :MeetingID="meetingId"
        :IsShowHeadPicture="true"
        :fatherSubmitDialog="editUserDialog"
        ref="editUser"
      ></EditUser>
      <EditExaminer
        :MeetingGroupID="userGroupId"
        :MeetingID="meetingId"
        :IsShowHeadPicture="true"
        :fatherSubmitDialog="editExaminerDialog"
        ref="editExaminer"
      ></EditExaminer>
      <ImportExcel
        :fatherSubmitDialog="importExcelDialog"
        ref="importUser"
      ></ImportExcel>
    </div>
  </div>
</template>
<script>
import voteUserApi from '../../../../api/vote/voteUser'
import EditUser from '@/components/wj_user/EditUser.vue'
import EditExaminer from '@/components/wj_user/EditExaminer.vue'
import ImportExcel from '@/components/wj_user/ImportExcel.vue'
export default {
  name: 'Home',
  components: {
    EditUser,
    EditExaminer,
    ImportExcel
  },
  data () {
    return {
      meetingId: null,
      userGroupId: null,
      tableLoading: true,
      userList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingGroupID: null,
        maxResultCount: 10,
        skipCount: 0
      },
      userGroupInfo: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    getVoteUserGroup: function () {
      this.tableLoading = true
      voteUserApi.getVoteUserGroup({
        meetingUserGroupID: this.userGroupId
      }).then(data => {
        this.userGroupInfo = data
        this.getVoteUsers()
      }).catch(err => {
        return err
      })
    },
    getVoteUsers: function () {
      this.tableLoading = true
      voteUserApi.getVoteUsers(this.listQuery).then(data => {
        this.userList = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getVoteUsers()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getVoteUsers()
    },
    deleteUser: function (item) {
      this.$confirm('确认删除学员“' + item.UserName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteUserApi.deleteVoteUser({
          groupStaffId: item.GroupStaffID
        }).then(data => {
          openLoading.close()
          this.getVoteUsers()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editUser: function (groupStaffId) {
      this.$refs.editUser.openEditUser(groupStaffId)
    },
    editExaminer: function (groupStaffId) {
      this.$refs.editExaminer.openEditUser(groupStaffId)
    },
    editUserDialog: function () {
      this.getVoteUsers()
    },
    editScrutineerDialog: function () {
      this.getVoteUsers()
    },
    editExaminerDialog: function () {
      this.getVoteUsers()
    },
    openUserGroupManager: function () {
      this.$router.push({ name: 'voteUserGroup', params: { mid: this.$route.params.mid } })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    exportTemplate: function () {
      const openLoading = this.openLoading('正在导出…')
      voteUserApi.exportWJUserTemplate({
        UserGroupID: this.userGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '答卷人员'
        if (this.userGroupId) {
          fileName = this.userGroupInfo.MeetingUserGroupName
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    importData: function () {
      this.$refs.importUser.openImportExcel(this.userGroupId, this.$route.params.mid)
    },
    importExcelDialog: function () {
      this.getVoteUsers()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.RoleId === 2) {
        return 'zhuchiren-row'
      }
      return ''
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.userGroupId = this.$route.params.gid
    this.listQuery.meetingGroupID = this.$route.params.gid
    this.getVoteUserGroup()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
.el-table .zhuchiren-row {
  background: #d9ecff;
}
</style>
